import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M27.711 29.598 2.78 3.928a8.8 8.8 0 0 1 1.509-1.526l24.931 25.67a8.8 8.8 0 0 1-1.509 1.526",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M2.78 28.071 27.707 2.406a8.8 8.8 0 0 1 1.517 1.518L4.29 29.598a8.8 8.8 0 0 1-1.51-1.527M16 12.333c-3.019-1.736-3.385-4.864-2.717-7.397.712-.606 3.946-.98 5.434 0 .668 2.533.302 5.661-2.717 7.397",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M18.9 5.333c.126-.9.573-1.8 1.1-2.481-.55-.01-.797.256-.802.534-.138-.356-.677-.335-.843-.142.602.372.138 1.032-.407.896a.55.55 0 0 1-.438-.464c.15-.008.27-.12.277-.257.007-.138-.101-.258-.25-.28-.15-.02-.292.064-.331.197s.037.272.178.322a.67.67 0 0 1-.702.277.52.52 0 0 1-.407-.518c0-.544.573-.628.745-.534-.011-.366-.642-.66-.836-.356A.92.92 0 0 0 16 1.333a.92.92 0 0 0-.183 1.194c-.195-.304-.825-.01-.837.356.172-.094.745-.01.745.534 0 .21-.12.445-.407.518a.67.67 0 0 1-.701-.277c.14-.05.217-.189.178-.322s-.182-.218-.331-.196c-.15.02-.257.141-.25.279.006.138.126.249.276.257a.55.55 0 0 1-.438.464c-.545.136-1.009-.524-.407-.896-.166-.193-.705-.214-.843.142-.006-.278-.252-.545-.802-.534.527.68.974 1.58 1.1 2.481.642-.366 1.73-.649 2.9-.649s2.258.283 2.9.65",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagJey = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagJey_default = SvgFlagJey;

export { FlagJey_default as default };
